<div class="select-none truncate" *ngIf="isOption === false">
  <div *ngIf="!!inputItem.id && !!inputItem.output" class="truncate">
    <span class="text-s400 font-semibold">
      {{ inputItem.output }}
    </span>

    <span class="ml-2">
      {{ inputItem.id }}
    </span>
  </div>

  <div *ngIf="!inputItem.output" class="truncate">{{ inputItem.id }}</div>
</div>

<div class="select-none truncate" *ngIf="isOption === true">
  <span class="text-s400 font-semibold">
    {{ inputItem.output }}
  </span>

  <span class="ml-2">
    {{ inputItem.id }}
  </span>
</div>
